import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { SplitButton } from 'primereact/splitbutton'

import {
  Badge,
  BadgeStatusEntrega,
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  Loading,
  NumeroDecimal,
  PageHeader,
  ThreeDots,
} from '../../../../components'

import { tableCellCentered } from '../../../../assets/js/styles'
import * as colors from '../../../../assets/js/colors'
import { showMessageBox, showLoadingBox, hideLoadingBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as RetornoHttp from '../../../../services/api/https/deliveries/retorno.http'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import _ from 'lodash'
import { FaBoxOpen, FaRedo, FaRetweet, FaRoute, FaTruck, FaUndo, FaUserCheck } from 'react-icons/fa'
import ModalInformacoes from './ModalInformacoes/ModalInformacoes'
import ModalRetornarVeiculo from './ModalRetornarVeiculo/ModalRetornarVeiculo'
import ModalEmitirCte from './Cte/ModalEmitirCte'
import ModalEmitirCteEmpresaCliente from './Cte/ModalEmitirCteEmpresaCliente'
import ModalEmitirMdfe from '../Cte/EmitirMdfe/ModalEmitirMdfe'
import {
  deleteCancelMdfe,
  getDocumentosRotaMdfe,
  postEmitMdfe,
  postEncerrarMdfe,
  postSyncMdfe,
} from '../../../../services/api/https/deliveries/mdfe.http'
import ModalCancelarMdfe from '../Mdfe/ModalCancelarMdfe'
import ModalEncerrarMdfe from '../Mdfe/ModalEncerrarMdfe'
import ModalEncerrarViagem from './ModalEncerrarViagem/ModalEncerrarViagem'
import { STATUS_MDFE_VIGENTE } from '../Ciot/ciot.util'
import ModalTentativaReentrega from './ModalTentativaReentrega/ModalTentativaReentrega'
import ModalNfDevolucao, { STATUS_COM_NF_DEVOLUCAO } from './ModalNfDevolucao/ModalNfDevolucao'
import {
  FiscalPermissions,
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'
import { MENSAGEM_NFSE_ENVIADA } from '../../../../constants/fiscal'
import ModalEmitirNfse from '../../Fiscal/EmitirNfse/ModalEmitirNfse'
import ModalSelecionarNotasNfse, {
  isNotaElegivelNfse,
} from '../../Fiscal/EmitirNfse/ModalSelecionarNotasNfse'
import { isNfseVigente } from '../../Fiscal/EmitirNfse/emitirNfse.util'
import BadgeNfseNota from '../../Fiscal/EmitirNfse/BadgeNfseNota'
import { getValorFrete } from '../../../../services/api/https/registration/regras-frete.http'
import ModalCliente from '../../Cadastros/Cliente/ModalCliente/ModalCliente'
import { getClientByDeliveryId } from '../../../../services/api/https/registration/client.http'
import ModalGerarPickingAutomatico from '../EnvioParaRota/ModalGerarPickingAutomatico'
import { ModalOcorrenciasEntrega } from '../Ocorrencias/OcorrenciaEntrega/OcorrenciasEntrega'

function RetornoVeiculoApuracao({ dispatch, selectedTp, history, notification }) {
  // Vars
  const {
    location: {
      state: { fleet_id, vehicle_badge, driver_id, driver_tp_id, expected_date, documentos_rota },
    },
  } = history

  // Hooks
  const [entregas, setEntregas] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [selecionarTodos, setSelecionarTodos] = useState(false)
  const [selecionarTodosComFalta, setSelecionarTodosComFalta] = useState(false)
  const [selecionarTodosSemFalta, setSelecionarTodosSemFalta] = useState(false)
  const [selecionarTodosStatusIniciais, setSelecionarTodosStatusIniciais] = useState(false)
  const [modalInformacoes, setModalInformacoes] = useState({ show: false, data: null })
  const [modalRetornarVeiculo, setModalRetornarVeiculo] = useState({ show: false, data: null })
  const [modalCte, setModalCte] = useState({ show: false, data: null, consolidado: null })
  const [modalCteEmpresaCliente, setModalCteEmpresaCliente] = useState({ show: false })
  const [modalMdfe, setModalMdfe] = useState({ show: false })
  const [modalDetalhesCliente, setModalDetalhesCliente] = useState({ show: false, data: null })
  const [modalTentativaReentrega, setModalTentativaReentrega] = useState({ show: false, data: null })
  const [modalNfDevolucao, setModalNfDevolucao] = useState({ show: false, data: null })
  const [modalReconferenciaHandler, setModalReconferenciaHandler] = useState({ isVisible: false })
  const [modalOcorrenciasEntrega, setModalOcorrenciasEntrega] = useState({
    show: false,
    data: null,
  })
  const [modalNotasNfse, setModalNotasNfse] = useState({ show: false })
  const [modalNfse, setModalNfse] = useState({ show: false, contexto: null })
  const [documentosRota, setDocumentosRota] = useState(documentos_rota || null)
  const consultaDocumentos = useRef(null)
  const [modalCancelarMdfe, setModalCancelarMdfe] = useState({ show: false, mdfe: null })
  const [modalEncerrarMdfe, setModalEncerrarMdfe] = useState({ show: false, mdfe: null })
  const [modalEncerrarViagem, setModalEncerrarViagem] = useState({
    show: false,
    mdfes: [],
    ciots: [],
  })

  // A NFS-e sai pelo TP da rota (o filtro de TP da tela pode estar em "Todos")
  const tpDaRota = entregas.length ? entregas[0].tp_id : selectedTp
  const podeEmitirNfse =
    menuItemsAllowed([{ id: FiscalPermissions.GESTAO_NFSE, content: '' }]).length > 0 &&
    verifyTpPermission(TpPermissions.FISCAL, tpDaRota)

  const podeGerirMdfe = menuItemsAllowed([{ id: 40, content: "3.18 - Gestão de CTe's" }]).length > 0
  const mdfesVigentes = (documentosRota ? documentosRota.mdfes : []).filter(mdfe =>
    STATUS_MDFE_VIGENTE.includes(mdfe.status),
  )

  useEffect(() => {
    getEntregas()
    if (podeGerirMdfe) carregarDocumentosRota()
  }, [fleet_id])

  const abrirEmissaoNfse = deliveriesIds => {
    setModalNotasNfse({ show: false })
    setModalNfse({
      show: true,
      contexto: {
        origem: 'rota',
        deliveries_ids: deliveriesIds,
        fleet_id,
        veiculo_placa: vehicle_badge,
      },
    })
  }

  // Events
  const onMenuItemClicked = async (menuItem, entrega) => {
    const { delivery_id, identifier, nomeFantasia, company_id, delivery_step_id, company_name } =
      entrega

    try {
      switch (menuItem) {
        case 'Informações':
          setModalInformacoes({ show: true, data: entrega })
          break
        case 'Anexar Canhoto':
          history.push('/main/entregas/anexar-canhoto', { delivery_id })
          break
        case 'Ocorrência Produto':
          history.push('/main/entregas/ocorrencias/faltas', {
            delivery_id,
            identifier,
            nomeFantasia,
            company_id,
            delivery_step_id,
          })
          break
        case 'Ocorrências Entrega':
          setModalOcorrenciasEntrega({ show: true, data: entrega })
          break
        case 'Emitir CTe':
          // Validar status do CTe e cálculo do frete ANTES de abrir o modal
          if (entrega.cte_status === 'autorizado') {
            throw new Error('Emissão de CTe já solicitada. Status: autorizado')
          }
          if (entrega.cte_status === 'processando_autorizacao') {
            throw new Error('Emissão de CTe já solicitada. Status: processando_autorizacao')
          }
          if (isNfseVigente(entrega.nfse_status)) {
            throw new Error(
              entrega.nfse_numero
                ? `Nota ${identifier} faturada pela NFS-e nº ${entrega.nfse_numero}; cancele a NFS-e na 11.1 para emitir o CT-e`
                : `Nota ${identifier} tem NFS-e em processamento; confira na 11.1 antes de emitir o CT-e`,
            )
          }
          try {
            await getValorFrete(delivery_id)
            // Se o cálculo foi bem-sucedido, abre o modal
            setModalCte({ show: true, data: entrega, consolidado: null })
          } catch (error) {
            // Se houver erro, exibe a mensagem e NÃO abre o modal
            throw error
          }
          break
        case 'Chat':
          history.push('/main/entregas/chat', {
            delivery_id,
            company_name,
            vehicle_badge,
            tp_id: selectedTp,
            driver_id,
            driver_tp_id,
            weight: entrega.weightTotal,
            expected_date,
          })
          break
        case 'Detalhes Cliente':
          const clienteData = await getClientByDeliveryId(delivery_id)
          setModalDetalhesCliente({ show: true, data: clienteData })
          break
        case 'Anexar NF Devolução':
          setModalNfDevolucao({ show: true, data: entrega })
          break
        case 'Emitir NFS-e':
          if (!isNotaElegivelNfse(entrega))
            throw new Error('Esta nota já tem CT-e ou NFS-e, ou o cliente fica fora do município')
          abrirEmissaoNfse([delivery_id])
          break
        default:
          throw new Error('Item do menu Incorreto')
      }
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onCheckboxClicked = entrega => {
    const index = entregas.findIndex(e => e.delivery_id === entrega.delivery_id)
    if (index !== -1) {
      const e = [...entregas]
      e[index].selected = e[index].selected ? !e[index].selected : true
      setEntregas(e)
    }
  }

  const onError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const carregarDocumentosRota = () => {
    const consulta = getDocumentosRotaMdfe(fleet_id)
      .then(documentos => {
        setDocumentosRota(documentos)
        return documentos
      })
      .catch(error => {
        onError(error)
        setDocumentosRota(atual => atual || { mdfes: [], ciots: [] })
        return null
      })
    consultaDocumentos.current = consulta
    return consulta
  }

  const executarAcaoMdfe = async (acao, mensagemSucesso) => {
    try {
      dispatch(showLoadingBox('Aguarde...', 'Processando MDFe'))
      await acao()
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(mensagemSucesso, null))
    } catch (error) {
      dispatch(hideLoadingBox())
      onError(error)
    }
    carregarDocumentosRota()
  }

  const onAcaoMdfe = (acao, mdfe) => {
    if (acao === 'cancelar') setModalCancelarMdfe({ show: true, mdfe })
    else if (acao === 'encerrar') setModalEncerrarMdfe({ show: true, mdfe })
    else if (acao === 'damdfe') window.open(mdfe.caminho_damdfe, '_blank')
    else if (acao === 'emitir') setModalMdfe({ show: true })
    else if (acao === 'sincronizar')
      executarAcaoMdfe(() => postSyncMdfe({ ref: mdfe.ref }), 'Status do MDFe sincronizado')
  }

  const onVeiculoRetornado = async () => {
    setModalRetornarVeiculo({ show: false, data: null })
    // A consulta sai no clique em "Retornar Veículo"; se ainda não voltou, vale o que a tela já tem
    const atualizados = podeGerirMdfe
      ? await Promise.race([
          consultaDocumentos.current || carregarDocumentosRota(),
          new Promise(resolve => setTimeout(() => resolve(null), ESPERA_MAXIMA_DOCUMENTOS_MS)),
        ])
      : null
    const documentos = atualizados || (podeGerirMdfe ? documentosRota : null)
    const mdfes = documentos ? documentos.mdfes.filter(mdfe => mdfe.status === 'autorizado') : []
    const ciots = documentos ? documentos.ciots.filter(ciot => ciot.status === 'declarado') : []
    if (mdfes.length || ciots.length) {
      setModalEncerrarViagem({ show: true, mdfes, ciots })
      return
    }
    history.goBack()
  }

  const onHeaderBtnClicked = async action => {
    try {
      if (action === 'retornar_veiculo') {
        if (podeGerirMdfe) carregarDocumentosRota()
        setModalRetornarVeiculo({ show: true, data: { fleet_id } })
        return
      } else if (action === 'relatorio_retorno_veiculo') {
        const selectedDeliveries = entregas.filter(d => d.selected)
        if (selectedDeliveries.some(sD => !['Devolução Total', 'Reentrega'].includes(sD.status))) {
          throw Error(
            'As entregas selecionadas devem estar com status Devolução Total ou Reentrega',
          )
        }
        const deliveriesIds = selectedDeliveries.map(d => d.delivery_id)
        if (deliveriesIds.length > 0) {
          window.open(RetornoHttp.relatorioRetornoVeiculo(deliveriesIds.toString(), '_blank'))
        } else {
          throw Error('É necessario selecionar pelo menos 1 entrega para emitir a relação.')
        }
      } else if (action === 'sobras') {
        history.push('/main/entregas/ocorrencias/sobras', {
          fleet_id,
          vehicle_badge,
        })
        return
      } else {
        //Demais actions: entrega_total, reentrega, devolucao_total, devolucao_parcial
        const selectedDeliveries = entregas.filter(d => d.selected)
        const deliveries_steps_vehicles_ids = selectedDeliveries.map(
          s => s.delivery_step_vehicle_id,
        )
        await RetornoHttp.postEntregasAction(selectedTp, deliveries_steps_vehicles_ids, action)
        await getEntregas()
      }
      dispatch(showMessageBox('Operação Realizada com Sucesso', null))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onSelecionarTodos = checked => {
    const ent = [...entregas]
    ent.forEach(e => (e.selected = checked))
    setEntregas(ent)
    setSelecionarTodos(checked)
  }
  const onSelecionarTodosComFalta = checked => {
    const ent = [...entregas]
    ent.forEach(e => (e.selected = checked && e.qte_faltas !== null))
    setEntregas(ent)
    setSelecionarTodosComFalta(checked)
  }
  const onSelecionarTodosSemFalta = checked => {
    const ent = [...entregas]
    ent.forEach(e => (e.selected = checked && e.qte_faltas === null))
    setEntregas(ent)
    setSelecionarTodosSemFalta(checked)
  }
  const onSelecionarTodosStatusIniciais = checked => {
    const statusIniciais = ['Saiu para Entrega']
    const ent = [...entregas]
    ent.forEach(e => (e.selected = checked && statusIniciais.includes(e.status)))
    setEntregas(ent)
    setSelecionarTodosStatusIniciais(checked)
  }

  const onGerarPickingReconferencia = () => {
    try {
      const selectedDeliveries = entregas.filter(d => d.selected)
      if (selectedDeliveries.length === 0) {
        dispatch(showMessageBox(null, 'Selecione pelo menos 1 entrega'))
        return
      }

      const VALID_STATUSES = ['Reentrega', 'Devolução Total']
      const invalidDeliveries = selectedDeliveries.filter(d => !VALID_STATUSES.includes(d.status))
      if (invalidDeliveries.length > 0) {
        const identifiers = invalidDeliveries.map(d => d.identifier).join(', ')
        dispatch(
          showMessageBox(
            null,
            `Erro ao gerar Picking, a(s) entrega(s) ${identifiers} possuem status inválidos para a Reconferência`,
          ),
        )
        return
      }

      setModalReconferenciaHandler({ isVisible: true })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onConfirmReconferencia = async ({
    area_association_model,
    pickingteam_id,
    preparar_para_download,
    descricoes,
  }) => {
    try {
      setModalReconferenciaHandler({ isVisible: false })
      dispatch(showLoadingBox('Gerando Picking de Reconferência...'))

      const selectedDeliveries = entregas.filter(d => d.selected)
      const { id: user_id } = getUsuarioInfo()

      await PickingHttp.gerarPickingReconferenciaAhPartirRoteirizacao({
        fleet_id,
        user_id,
        area_association_model,
        pickingteam_id,
        preparar_para_download,
        picking_name: descricoes && descricoes.length ? descricoes[0].name : undefined,
        associacoes: selectedDeliveries.map(d => ({ step_id: d.delivery_step_id })),
      })

      dispatch(showMessageBox('Picking de Reconferência gerado com sucesso', null))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  // Helper
  const getEntregas = async () => {
    try {
      const fetchedEntregas = await RetornoHttp.getEntregas(fleet_id, selectedTp)
      const deliveriesDesc = _.orderBy(fetchedEntregas, 'load_order', 'desc')
      deliveriesDesc.forEach((e, index) => (e.load_order = e.load_order ? index + 1 : ''))

      setIsLoading(false)
      setEntregas(deliveriesDesc)
      setSelecionarTodos(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return (
    <>
      <PageHeader>
        Retorno do Veículo &nbsp;
        <strong>{vehicle_badge}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div
              className="p-col-12"
              style={{
                borderRadius: '10px',
                overflow: 'hidden',
                padding: 0,
                margin: '8px',
                width: 'auto',
              }}
            >
              <div title="Entrega Total" style={{ display: 'inline-block' }}>
                <Btn
                  onClick={() => onHeaderBtnClicked('entrega_total')}
                  style={{ minWidth: 'auto' }}
                >
                  <FaTruck size={20} />
                </Btn>
              </div>
              <div title="Reentrega" style={{ display: 'inline-block' }}>
                <Btn
                  backgroundColor={colors.laranja}
                  onClick={() => onHeaderBtnClicked('reentrega')}
                  style={{ minWidth: 'auto' }}
                >
                  <FaRedo size={20} />
                </Btn>
              </div>
              <div title="Devolução Total" style={{ display: 'inline-block' }}>
                <Btn
                  backgroundColor={colors.vinho}
                  onClick={() => onHeaderBtnClicked('devolucao_total')}
                  style={{ minWidth: 'auto' }}
                >
                  <FaUndo size={20} />
                </Btn>
              </div>
              <div title="Devolução Parcial" style={{ display: 'inline-block' }}>
                <Btn
                  backgroundColor={colors.azul_escuro}
                  onClick={() => onHeaderBtnClicked('devolucao_parcial')}
                  style={{ minWidth: 'auto' }}
                >
                  <FaRetweet size={20} />
                </Btn>
              </div>
              <div title="Em Rota" style={{ display: 'inline-block' }}>
                <Btn
                  backgroundColor={colors.violeta}
                  onClick={() => onHeaderBtnClicked('em_rota')}
                  style={{ minWidth: 'auto' }}
                >
                  <FaRoute size={20} />
                </Btn>
              </div>
              <div title="No Cliente" style={{ display: 'inline-block' }}>
                <Btn
                  backgroundColor={colors.verde_escuro}
                  onClick={() => onHeaderBtnClicked('no_cliente')}
                  style={{ minWidth: 'auto' }}
                >
                  <FaUserCheck size={20} />
                </Btn>
              </div>
              <div title="Descarregando" style={{ display: 'inline-block' }}>
                <Btn
                  backgroundColor={colors.roxo}
                  onClick={() => onHeaderBtnClicked('descarregando')}
                  style={{ minWidth: 'auto' }}
                >
                  <FaBoxOpen size={20} />
                </Btn>
              </div>
            </div>

            <div
              className="p-col-12"
              style={{
                borderRadius: '10px',
                overflow: 'hidden',
                padding: 0,
                margin: '8px',
                width: 'auto',
              }}
            >
              <div title="Retornar Veículo" style={{ display: 'inline-block' }}>
                <Btn
                  backgroundColor={colors.black}
                  onClick={() => onHeaderBtnClicked('retornar_veiculo')}
                  style={{ minWidth: 'auto', padding: '14px' }}
                >
                  Retornar Veículo
                </Btn>
              </div>
              <div title="Relatório de Retorno de Veiculo" style={{ display: 'inline-block' }}>
                <Btn
                  backgroundColor={colors.pink}
                  onClick={() => onHeaderBtnClicked('relatorio_retorno_veiculo')}
                  style={{ minWidth: 'auto', padding: '14px' }}
                >
                  Relatório de Retorno de Veiculo
                </Btn>
              </div>
              
            </div>
            <div
              className="p-col-12"
              style={{
                overflow: 'hidden',
                padding: 0,
                margin: '8px',
                width: 'auto',
              }}
            >
               <Btn
                  backgroundColor={colors.laranja}
                  onClick={onGerarPickingReconferencia}
                  style={{ minWidth: 'auto', padding: '14px', borderRadius: '10px' }}
                >
                  Gerar Picking - Reconferência
                </Btn>
            </div>
            <div
              className="p-col-12"
              style={{
                overflow: 'hidden',
                padding: 0,
                margin: '8px',
                width: 'auto',
              }}
            >
              <Btn
                backgroundColor={colors.azul}
                onClick={() => onHeaderBtnClicked('sobras')}
                style={{ minWidth: 'auto', padding: '14px', borderRadius: '10px' }}
              >
                Sobras
              </Btn>
              {menuItemsAllowed([{ id: 40, content: "3.18 - Gestão de CTe's" }]).length > 0 && (
                <div style={{ display: 'inline-block', marginLeft: 8 }}>
                  <Btn
                    backgroundColor={colors.verde_escuro}
                    onClick={() => setModalCteEmpresaCliente({ show: true })}
                    style={{ minWidth: 'auto', padding: '14px', borderRadius: '10px' }}
                  >
                    Emitir CTe Empresa-Cliente
                  </Btn>
                  {!documentosRota ? (
                    <div style={{ display: 'inline-block', marginLeft: 8, verticalAlign: 'middle' }}>
                      <Btn isLoading={true} />
                    </div>
                  ) : mdfesVigentes.length ? (
                    mdfesVigentes.map(mdfe => (
                      <BotaoMdfeVigente key={mdfe.id} mdfe={mdfe} onAcao={onAcaoMdfe} />
                    ))
                  ) : (
                    <Btn
                      backgroundColor={colors.roxo}
                      onClick={() => setModalMdfe({ show: true })}
                      style={{
                        minWidth: 'auto',
                        padding: '14px',
                        borderRadius: '10px',
                        marginLeft: 8,
                      }}
                    >
                      Emitir MDFe
                    </Btn>
                  )}
                </div>
              )}
              {podeEmitirNfse && (
                <div style={{ display: 'inline-block', marginLeft: 8 }}>
                  <Btn
                    backgroundColor={colors.azul_escuro}
                    onClick={() => setModalNotasNfse({ show: true })}
                    style={{ minWidth: 'auto', padding: '14px', borderRadius: '10px' }}
                  >
                    Emitir NFS-e
                  </Btn>
                </div>
              )}
            </div>
            <div className="p-col-12 p-mt-1 p-mb-1">
              <CustomCheckbox checked={selecionarTodos} onChange={onSelecionarTodos}>
                Selecionar Todos
              </CustomCheckbox>
              <div style={{ display: 'inline-block', marginLeft: 15 }}>
                <CustomCheckbox
                  checked={selecionarTodosSemFalta}
                  onChange={onSelecionarTodosSemFalta}
                >
                  Selecionar Todos SEM Falta
                </CustomCheckbox>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 15 }}>
                <CustomCheckbox
                  checked={selecionarTodosComFalta}
                  onChange={onSelecionarTodosComFalta}
                >
                  Selecionar Todos COM Falta
                </CustomCheckbox>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 15 }}>
                <CustomCheckbox
                  checked={selecionarTodosStatusIniciais}
                  onChange={onSelecionarTodosStatusIniciais}
                >
                  Selecionar todos Saiu para Entrega
                </CustomCheckbox>
              </div>
            </div>

            <div className="p-col-12">
              {isLoading ? (
                <div className="text-center" style={{ marginTop: 20 }}>
                  <Loading />
                </div>
              ) : (
                <DataTableComponent
                  entregas={entregas}
                  onMenuItemClicked={onMenuItemClicked}
                  onCheckboxClicked={onCheckboxClicked}
                  notification={notification}
                  onReentregaBadgeClicked={entrega => setModalTentativaReentrega({ show: true, data: entrega })}
                  podeEmitirNfse={podeEmitirNfse}
                />
              )}
            </div>
          </div>
        </CustomPanel>

        <ModalInformacoes
          show={modalInformacoes.show}
          onModalClose={() => {
            setModalInformacoes({ show: false, data: null })
          }}
          onModalSave={() => {
            setModalInformacoes({ show: false, data: null })
            getEntregas()
          }}
          entrega={modalInformacoes.data}
        />
        <ModalRetornarVeiculo
          show={modalRetornarVeiculo.show}
          onModalClose={() => {
            setModalRetornarVeiculo({ show: false, data: null })
          }}
          onModalSave={onVeiculoRetornado}
          fleet={modalRetornarVeiculo.data}
        />
        <ModalEmitirCte
          selectedTp={selectedTp}
          delivery={modalCte.data}
          consolidado={modalCte.consolidado}
          visible={modalCte.show}
          vehicleBadge={vehicle_badge}
          onModalClose={() => {
            setModalCte({ show: false, data: null, consolidado: null })
          }}
          onModalSave={() => {
            dispatch(showMessageBox('CTe enviada para emissão, aguardando resposta SEFAZ', null))

            setModalCte({ show: false, data: null, consolidado: null })
            getEntregas()
          }}
          onError={onError}
        />
        <ModalEmitirMdfe
          isVisible={modalMdfe.show}
          origem="nfe"
          fleetId={fleet_id}
          ctes={null}
          selectedTp={selectedTp}
          onClose={() => setModalMdfe({ show: false })}
          onError={onError}
          onSave={async body => {
            try {
              dispatch(showLoadingBox('Aguarde...', 'Solicitando MDFe'))
              await postEmitMdfe(body)
              dispatch(hideLoadingBox())
              setModalMdfe({ show: false })
              dispatch(showMessageBox('MDFe enviado para emissão, aguardando resposta SEFAZ', null))
              carregarDocumentosRota()
            } catch (error) {
              dispatch(hideLoadingBox())
              onError(error)
            }
          }}
          onMdfeVinculado={() => {
            setModalMdfe({ show: false })
            dispatch(showMessageBox('MDFe vinculado à rota', null))
            carregarDocumentosRota()
          }}
        />
        <ModalCancelarMdfe
          isVisible={modalCancelarMdfe.show}
          mdfe={modalCancelarMdfe.mdfe}
          onCancel={() => setModalCancelarMdfe({ show: false, mdfe: null })}
          onSave={mdfe => {
            setModalCancelarMdfe({ show: false, mdfe: null })
            executarAcaoMdfe(
              () => deleteCancelMdfe({ ref: mdfe.ref, justificativa: mdfe.justificativa }),
              'MDFe cancelado com sucesso',
            )
          }}
          onError={onError}
        />
        <ModalEncerrarMdfe
          isVisible={modalEncerrarMdfe.show}
          mdfe={modalEncerrarMdfe.mdfe}
          sugestao={modalEncerrarMdfe.mdfe ? modalEncerrarMdfe.mdfe.encerramento_sugerido : null}
          onCancel={() => setModalEncerrarMdfe({ show: false, mdfe: null })}
          onSave={mdfe => {
            setModalEncerrarMdfe({ show: false, mdfe: null })
            executarAcaoMdfe(
              () =>
                postEncerrarMdfe({
                  ref: mdfe.ref,
                  sigla_uf: mdfe.sigla_uf,
                  nome_municipio: mdfe.nome_municipio,
                }),
              'MDFe encerrado com sucesso',
            )
          }}
          onError={onError}
        />
        <ModalEncerrarViagem
          visible={modalEncerrarViagem.show}
          mdfes={modalEncerrarViagem.mdfes}
          ciots={modalEncerrarViagem.ciots}
          // Sem esconder o modal antes de sair: o Dialog chamaria onClose de novo e voltaria duas telas
          onClose={() => history.goBack()}
          onConcluido={resultados => {
            const texto = resultados.map(resultado => resultado.texto).join('\n')
            const falhou = resultados.some(resultado => !resultado.sucesso)
            dispatch(showMessageBox(falhou ? null : texto, falhou ? texto : null))
            history.goBack()
          }}
          onError={onError}
        />
        <ModalEmitirCteEmpresaCliente
          visible={modalCteEmpresaCliente.show}
          entregas={entregas}
          onModalClose={() => setModalCteEmpresaCliente({ show: false })}
          onCadastrar={consolidado => {
            setModalCteEmpresaCliente({ show: false })
            setModalCte({ show: true, data: null, consolidado })
          }}
          onError={onError}
        />
        <ModalCliente
          show={modalDetalhesCliente.show}
          selectedCliente={modalDetalhesCliente.data}
          onModalClose={() => setModalDetalhesCliente({ show: false, data: null })}
          onModalSave={() => {}}
          readOnly={true}
        />
        <ModalTentativaReentrega
          show={modalTentativaReentrega.show}
          entrega={modalTentativaReentrega.data}
          readOnly={false}
          onModalClose={() => setModalTentativaReentrega({ show: false, data: null })}
          onModalSave={updatedEntrega => {
            setModalTentativaReentrega({ show: false, data: null })
            getEntregas()
          }}
        />
        <ModalNfDevolucao
          show={modalNfDevolucao.show}
          entrega={modalNfDevolucao.data}
          onModalClose={() => setModalNfDevolucao({ show: false, data: null })}
        />
        <ModalGerarPickingAutomatico
          header="Gerar Picking - Reconferência"
          estilo="Reconferencia"
          fleetIds={[fleet_id]}
          tpId={selectedTp}
          isVisible={modalReconferenciaHandler.isVisible}
          onClose={() => setModalReconferenciaHandler({ isVisible: false })}
          onSave={onConfirmReconferencia}
        />
        <ModalSelecionarNotasNfse
          visible={modalNotasNfse.show}
          entregas={entregas}
          onClose={() => setModalNotasNfse({ show: false })}
          onContinuar={abrirEmissaoNfse}
          onError={onError}
        />
        <ModalEmitirNfse
          visible={modalNfse.show}
          tpId={tpDaRota}
          contexto={modalNfse.contexto}
          onClose={() => setModalNfse({ show: false, contexto: null })}
          onEmitida={nfse => {
            setModalNfse({ show: false, contexto: null })
            dispatch(showMessageBox(nfse.aviso ? null : MENSAGEM_NFSE_ENVIADA, nfse.aviso || null))
            getEntregas()
          }}
          onError={onError}
        />
        <ModalOcorrenciasEntrega
          visible={modalOcorrenciasEntrega.show}
          deliveryStepVehicleId={
            modalOcorrenciasEntrega.data
              ? modalOcorrenciasEntrega.data.delivery_step_vehicle_id
              : null
          }
          fleetId={fleet_id}
          identifier={modalOcorrenciasEntrega.data ? modalOcorrenciasEntrega.data.identifier : null}
          onClose={() => setModalOcorrenciasEntrega({ show: false, data: null })}
        />
      </div>
    </>
  )
}

const PRAZO_CANCELAMENTO_MDFE_MS = 24 * 60 * 60 * 1000
const ESPERA_MAXIMA_DOCUMENTOS_MS = 1000

function BotaoMdfeVigente({ mdfe, onAcao }) {
  const rotulo = mdfe.numero ? `MDFe ${mdfe.numero}` : 'MDFe'
  const itens = []
  let label = `Encerrar ${rotulo}`
  let acaoPrincipal = 'encerrar'
  if (mdfe.status === 'processando_autorizacao') {
    label = 'MDFe aguardando SEFAZ'
    acaoPrincipal = 'sincronizar'
  } else if (Date.now() - new Date(mdfe.created_at).getTime() < PRAZO_CANCELAMENTO_MDFE_MS) {
    label = `Cancelar ${rotulo}`
    acaoPrincipal = 'cancelar'
    itens.push({ label: `Encerrar ${rotulo}`, acao: 'encerrar' })
  }
  if (mdfe.caminho_damdfe) itens.push({ label: 'DAMDFE', acao: 'damdfe' })
  if (acaoPrincipal !== 'sincronizar')
    itens.push({ label: 'Sincronizar status', acao: 'sincronizar' })
  itens.push({ label: 'Emitir outro MDFe (rota mista)', acao: 'emitir' })

  return (
    <div style={{ display: 'inline-block', marginLeft: 8, verticalAlign: 'middle' }}>
      <SplitButton
        className="bck-primary"
        label={label}
        appendTo={document.body}
        menuStyle={{ width: 260 }}
        onClick={() => onAcao(acaoPrincipal, mdfe)}
        model={itens.map(item => ({ label: item.label, command: () => onAcao(item.acao, mdfe) }))}
      />
    </div>
  )
}

function DataTableComponent({
  entregas,
  onMenuItemClicked,
  onCheckboxClicked,
  notification,
  onReentregaBadgeClicked,
  podeEmitirNfse,
}) {
  // Hooks
  const [globalFilter, setGlobalFilter] = useState('')

  // Helpers

  function verifyMenuItemAllowed(menuItem) {
    return menuItemsAllowed([menuItem]).length > 0
  }

  function menuItems(entrega) {
    const MENU_ITEMS = [
      'Anexar Canhoto',
      'Ocorrência Produto',
      'Ocorrências Entrega',
      'Chat',
      'Detalhes Cliente',
    ]

    if (['Entregue', 'Devolução Parcial'].indexOf(entrega.status) > -1)
      MENU_ITEMS.unshift('Informações')

    if (verifyMenuItemAllowed({ id: 40, content: "3.18 - Gestão de CTe's" })) {
      MENU_ITEMS.push('Emitir CTe')
    }

    if (podeEmitirNfse && isNotaElegivelNfse(entrega)) MENU_ITEMS.push('Emitir NFS-e')

    // Quando o TP exige a documentação na baixa manual (S.5), a NF é anexada antes da Devolução Parcial
    if (STATUS_COM_NF_DEVOLUCAO.includes(entrega.status) || entrega.baixa_manual_exige_documentacao)
      MENU_ITEMS.push('Anexar NF Devolução')

    return MENU_ITEMS
  }
  // Render
  return (
    <DataTable
      value={entregas}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
      globalFilter={globalFilter}
      paginator={true}
      rows={10}
    >
      <Column
        header=""
        style={tableCellCentered(80)}
        body={entrega => (
          <CustomCheckbox checked={entrega.selected} onChange={() => onCheckboxClicked(entrega)} />
        )}
      />
      <Column header="Ordem" field="load_order" style={tableCellCentered(100)} />
      <Column field="identifier" header="Identif." />
      <Column field="nomeFantasia" header="Fantasia" />
      <Column field="city" header="Cidade" style={tableCellCentered(150)} />
      <Column field="district" header="Bairro" style={tableCellCentered()} />
      <Column field="company_name" header="Empresa" />
      <Column
        field="weightTotal"
        header="Peso"
        body={item => <NumeroDecimal>{item.weightTotal}</NumeroDecimal>}
        style={tableCellCentered()}
      />
      <Column field="qte_sku" header="Qte. Sku" style={tableCellCentered()} />
      <Column
        field="status"
        header="Status"
        style={tableCellCentered(130)}
        body={entrega => {
          if (entrega.status === 'Reentrega') {
            return (
              <span
                style={{ cursor: 'pointer' }}
                title="Clique para registrar tentativa de reentrega"
                onClick={() => onReentregaBadgeClicked(entrega)}
              >
                <BadgeStatusEntrega status={entrega.status} />
              </span>
            )
          }
          return <BadgeStatusEntrega status={entrega.status} />
        }}
      />
      <Column
        style={tableCellCentered(130)}
        header="Possui Falta"
        body={entrega => {
          return entrega.qte_faltas ? (
            <Badge color={colors.vinho}>sim</Badge>
          ) : (
            <Badge color={colors.verde}>não</Badge>
          )
        }}
      />
      <Column
        style={tableCellCentered(130)}
        header="CTe"
        body={entrega => {
          const getColorAndText = () => {
            if (entrega.cte_status === 'autorizado') return { color: colors.verde, text: 'Emitido' }
            if (entrega.cte_status === 'processando_autorizacao')
              return { color: colors.laranja, text: 'Processando Emissão' }
            if (isNfseVigente(entrega.nfse_status)) return { color: colors.gray, text: 'Via NFS-e' }
            return { color: colors.vermelho, text: 'Não Emitido' }
          }
          const { color, text } = getColorAndText()
          return <Badge color={color}>{text}</Badge>
        }}
      />
      <Column
        style={tableCellCentered(130)}
        header="NFS-e"
        body={entrega => <BadgeNfseNota entrega={entrega} />}
      />
      <Column
        header="Menu"
        style={tableCellCentered(70)}
        body={entrega => (
          <div>
            {notification.deliveries_ids.includes(entrega.delivery_id) && (
              <span
                style={{
                  position: 'absolute',
                  width: '10px',
                  height: '10px',
                  backgroundColor: '#14b0bf',
                  borderRadius: '50%',
                  marginLeft: '10px',
                }}
              />
            )}
            <ThreeDots
              items={menuItems(entrega)}
              onClick={item => onMenuItemClicked(item, entrega)}
            />
          </div>
        )}
        bodyStyle={tableCellCentered()}
      />
    </DataTable>
  )
}

const mapToProps = ({ system: { selectedTp }, notification }) => ({ selectedTp, notification })
export default connect(mapToProps)(withRouter(RetornoVeiculoApuracao))
